import {
    AggregateFunctions,
    AggregateQueryInterval,
} from "~/modules/filters/types";
import {
    ApiToolsControls,
    BooleanControlState,
    SelectControlProps,
} from "./types";
import { TokenTimeseriesGroupBy } from "~/modules/token_timeseries/types";

// // // //

export const DEFAULT_STACKED_CONTROLS: BooleanControlState = {
    enabled: true,
    active: false,
    forceUpdate: false,
};

export const DEFAULT_LEGEND_CONTROLS: BooleanControlState = {
    enabled: true,
    active: true,
    forceUpdate: false,
};

export const DEFAULT_NAVIGATOR_CONTROLS: BooleanControlState = {
    enabled: true,
    active: false,
    forceUpdate: false,
};

export const DEFAULT_GROUP_BY_CONTROLS: SelectControlProps<TokenTimeseriesGroupBy> =
    {
        enabled: false,
        forceUpdate: false,
        value: TokenTimeseriesGroupBy.asset,
        allowedOptions: [
            TokenTimeseriesGroupBy.network,
            TokenTimeseriesGroupBy.asset,
            TokenTimeseriesGroupBy.token,
            TokenTimeseriesGroupBy.peggedAsset,
            TokenTimeseriesGroupBy.jurisdictionCountry,
            TokenTimeseriesGroupBy.measure,
        ],
    };

export const DEFAULT_AGGREGATE_FUNCTION_CONTROLS: SelectControlProps<AggregateFunctions> =
    {
        enabled: false,
        forceUpdate: false,
        value: AggregateFunctions.Sum,
        allowedOptions: [
            AggregateFunctions.Sum,
            AggregateFunctions.Avg,
            AggregateFunctions.Min,
            AggregateFunctions.Max,
        ],
    };

export const DEFAULT_AGGREGATE_INTERVAL_CONTROLS: SelectControlProps<AggregateQueryInterval> =
    {
        enabled: false,
        forceUpdate: true,
        value: AggregateQueryInterval.day,
        allowedOptions: [
            AggregateQueryInterval.day,
            AggregateQueryInterval.week,
            AggregateQueryInterval.month,
            AggregateQueryInterval.quarter,
            AggregateQueryInterval.year,
        ],
    };

export const TOKEN_TIMESERIES_V4_API_TOOLS_CONTROLS: ApiToolsControls = {
    enabled: true,
    baseUrl: "/v4/tokens/aggregates/timeseries",
};

export const ASSET_TIMESERIES_V4_API_TOOLS_CONTROLS: ApiToolsControls = {
    enabled: true,
    baseUrl: "/v4/assets/aggregates/timeseries",
};

export const FUND_FLOWS_TIMESERIES_V4_API_TOOLS_CONTROLS: ApiToolsControls = {
    enabled: true,
    baseUrl: "/v4/tokens/aggregates/fund_flows/timeseries",
};
